export const CREATE_REFERRAL = "CREATE_REFERRAL";
export const CREATE_REFERRAL_START = "CREATE_REFERRAL_START";
export const CREATE_REFERRAL_FAILED = "CREATE_REFERRAL_FAILED";
